import { render, staticRenderFns } from "./ProcessingRecipes.vue?vue&type=template&id=33bd27f0&"
import script from "./ProcessingRecipes.vue?vue&type=script&lang=ts&"
export * from "./ProcessingRecipes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports